import { FunctionComponent } from "react";
import EntityDashboard from "../components/entity_dashboard";

const BUDashboardScreen: FunctionComponent = () => (
  <EntityDashboard variant="bu" />
);

export default BUDashboardScreen;
